import api from '@/services/api'

/**
 * Módulos contratados por la instalación (server: GET /config). Se refresca
 * tras el login y en cada sincronización; persiste para funcionar sin
 * cobertura. Lo que el server no declara está apagado.
 */
export default {
  namespaced: true,
  state: {
    features: {},
  },
  getters: {
    tiene: state => modulo => state.features?.[modulo] === true,
  },
  mutations: {
    SET_FEATURES(state, features) {
      state.features = features || {}
    },
  },
  actions: {
    async fetch({ commit }) {
      try {
        const { data } = await api.get('config')
        commit('SET_FEATURES', data.features)
      } catch (error) {
        // Server que aún no expone /config: nada contratado. Sin red o con
        // otro fallo se conserva lo último conocido.
        if (error.response?.status === 404) commit('SET_FEATURES', {})
      }
    },
  },
}
